export const SCREEN_RECORDING_PERMISSION_NEEDED_EVENT =
  "denker:screen-recording-permission-needed";
